export const URL_PARAMS: Record<
  "production" | "staging",
  {
    domainWithoutLocale: string;
    ios: { ibi: string };
    android: { apn: string };
  }
> = {
  production: {
    domainWithoutLocale: "https://www.otrium.",
    ios: {
      ibi: "com.otrium.shop",
    },
    android: {
      apn: "com.otrium.shop",
    },
  },
  staging: {
    domainWithoutLocale: "https://staging.otrium.",
    ios: {
      ibi: "com.otrium.shop.staging",
    },
    android: {
      apn: "com.otrium.shop.staging",
    },
  },
} as const;
